module.exports = __webpack_public_path__ + "media/images/shared/delivery/ratek-36ffc633aff5560da633ba1ca3885180.png";